module.exports = __webpack_public_path__ + "static/media/snapscope-3.0a2922b8.jpg";